import React from 'react'

import axios from 'axios'

import './ContactForm.css'


const WINDOWS_LOCATION = typeof window !== 'undefined' && window.location.href
const API_PATH = `${WINDOWS_LOCATION}//api/sendEmail.php`

class contactForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fname: '',
      lname: '',
      email: '',
      message: '',
      mailSent: false,
      error: null,
    }
  }

  handleFormSubmit = e => {
    //console.log("Button pressed");
    e.preventDefault()
    axios({
      method: 'post',
      url: `${API_PATH}`,
      headers: { 'content-type': 'application/json' },
      data: this.state,
    })
      .then(result => {
        //console.log(result)
        this.setState({
          mailSent: result.data.sent,
        })
      })
      .catch(
        error => this.setState({ error: error.message }
    ))
  }

  render() {
    return (
      <div className="contact-form">
        <h2>Contattaci</h2>
        <div className="contact-form-description">
            <div className="p">
              Vuoi chiederci qualche informazione o richiedere un appuntamento? 
              Allora puoi entrare in contatto con noi semplicemente compilando le seguenti informazioni e premendo sul tasto INVIO.
            </div>
            <div className="p">
              Ricordati di controllare il campo indirizzo email così da poter essere ricontattato
            </div>
        </div>
        <div className="contact-form-input">
          <form action="#" onSubmit={this.handleSubmit}>
            {/* <label>Nome</label> */}
            <input
              type="text"
              id="fname"
              name="firstname"
              placeholder="Nome.."
              value={this.state.fname}
              onChange={e => this.setState({ fname: e.target.value })}
            />
            {/* <label>Cognome</label> */}
            <input
              type="text"
              id="lname"
              name="lastname"
              placeholder="Cognome.."
              value={this.state.lname}
              onChange={e => this.setState({ lname: e.target.value })}
            />

            {/* <label>Email</label> */}
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Indirizzo email.."
              value={this.state.email}
              onChange={e => this.setState({ email: e.target.value })}
            />

            {/* <label>Messaggio</label> */}
            <textarea
              id="message"
              name="message"
              placeholder="Scrivi il tuo messaggio.."
              onChange={e => this.setState({ message: e.target.value })}
              value={this.state.message}
            />
            <input
              type="submit"
              onClick={e => this.handleFormSubmit(e)}
              value="INVIO"
            />
            {/* <button>Send data!</button> */}
            <div>
              {this.state.mailSent && <div>Grazie per averci contattato</div>}
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default contactForm
